export type CsvCell = string | number | null | undefined;

/** Excel reads the file as UTF-8 only with the byte order mark. */
const BOM = '\uFEFF';

// A cell starting like a formula would run as one in a spreadsheet; the quote keeps it text.
const FORMULA = /^[=+\-@\t\r]/;

function cell(value: CsvCell, separator: string): string {
  if (value === null || value === undefined) return '';
  let text = String(value);
  if (typeof value === 'string' && FORMULA.test(text)) text = `'${text}`;
  return text.includes(separator) || /["\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Rows as a CSV file's text: UTF-8 with its byte order mark, CRLF line ends. Semicolons by
 * default, the separator Excel expects in Serbian and most European regional settings.
 */
export function toCsv(rows: readonly (readonly CsvCell[])[], separator = ';'): string {
  return (
    BOM +
    rows.map((row) => row.map((v) => cell(v, separator)).join(separator)).join('\r\n') +
    '\r\n'
  );
}

/** A name every system accepts as a file name: no path or reserved characters, one space at most. */
export const fileName = (name: string, maxLength = 150): string =>
  name
    .replace(/[\\/:*?"<>|\p{Cc}]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLength)
    .replace(/[ .]+$/, '');
